import React from "react";
import { Provider } from "components/action-job/ActionJobContext";
import { ActionJobList } from "components/action-job/ActionJobList";

export const ActionJobs = () => {
    return (
        <Provider>
            <ActionJobList />
        </Provider>
    );
};
